import CONSTANTS from '../../constants'

const {
  ACCESS_TOKEN_STORAGE_KEY,
  REFRESH_TOKEN_STORAGE_KEY,
  ACTIVE_ROLE_STORAGE_KEY,
  RECAPTCHA_TOKEN_STORAGE_KEY
} = CONSTANTS

type AuthTokens = {
  accessToken: string
  refreshToken: string
}

const Storage = () => {
  const getObject = (key: string) =>
    JSON.parse(localStorage.getItem(key) || '{}')

  const setObject = (key: string, value: object) =>
    localStorage.setItem(key, JSON.stringify(value))

  const getListParams = (resource: string) =>
    getObject(`RaStore.${resource}.listParams`)

  const getAccessToken = () => localStorage.getItem(ACCESS_TOKEN_STORAGE_KEY)
  const getRefreshToken = () => localStorage.getItem(REFRESH_TOKEN_STORAGE_KEY)

  const getActiveRole = () => getObject(ACTIVE_ROLE_STORAGE_KEY)
  const setActiveRole = (role: object) => {
    setObject(ACTIVE_ROLE_STORAGE_KEY, role)
    window.dispatchEvent(new Event('activeRoleChanged'))
  }

  const setAuthTokens = ({ accessToken, refreshToken }: AuthTokens) => {
    localStorage.setItem(ACCESS_TOKEN_STORAGE_KEY, accessToken)
    localStorage.setItem(REFRESH_TOKEN_STORAGE_KEY, refreshToken)
  }

  const getAuthTokens = (): AuthTokens => ({
    accessToken: getAccessToken() || '',
    refreshToken: getRefreshToken() || ''
  })

  const setRecaptchaToken = (token: string) =>
    localStorage.setItem(RECAPTCHA_TOKEN_STORAGE_KEY, token)

  const getRecaptchaToken = () =>
    localStorage.getItem(RECAPTCHA_TOKEN_STORAGE_KEY)

  return {
    getObject,
    setObject,
    getListParams,
    getAccessToken,
    getRefreshToken,
    getActiveRole,
    setActiveRole,
    setAuthTokens,
    getAuthTokens,
    setRecaptchaToken,
    getRecaptchaToken
  }
}

export default Storage
